// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("bs-platform/lib/js/array.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var ReasonReact = require("reason-react/src/ReasonReact.js");
var ReactFontawesome = require("@fortawesome/react-fontawesome");

function make(icon, id, className, style, size, fixedWidth, children) {
  var tmp = {
    icon: $$Array.of_list(icon)
  };
  if (id !== undefined) {
    tmp.id = Caml_option.valFromOption(id);
  }
  if (className !== undefined) {
    tmp.className = Caml_option.valFromOption(className);
  }
  if (style !== undefined) {
    tmp.style = Caml_option.valFromOption(style);
  }
  if (size !== undefined) {
    tmp.size = Caml_option.valFromOption(size);
  }
  if (fixedWidth !== undefined) {
    tmp.fixedWidth = Caml_option.valFromOption(fixedWidth);
  }
  return ReasonReact.wrapJsForReason(ReactFontawesome.FontAwesomeIcon, tmp, children);
}

exports.make = make;
/* ReasonReact Not a pure module */
